/**
 * Toggle
 * ======================================
 * - css required!
 .slideToggle {
  height: 0;
  overflow: hidden;
  transition: .3s ease height;
}
 * - toggle height on [data-toggle] selector
 * - toggle ELEMENT_LABEL text with [data-toggle-label] attribute
 */

 const ELEMENTS = ".js-SlideToggle";
 const ELEMENT_LABEL = ".js-toggle-label";
 const TOGGLE_CLASS = "is-toggled";

 class SlideToggle {
   constructor() {
     this.elements = document.querySelectorAll(ELEMENTS);

     if (!this.elements) {
       return false;
     }

     this.elements.forEach((el) => {
       el.addEventListener("click", this.toggle);
     });
   }

   toggle = (e) => {
     const el = e.currentTarget;
     const label = el.querySelector(ELEMENT_LABEL);
     const currentLabel = label.innerHTML;
     const newLabel = el.getAttribute("data-toggle-label");
     const target = document.querySelector(el.getAttribute("data-toggle"));
     const classes = target.classList

     if (!target) {
       return false;
     }

     if (newLabel) {
       label.innerHTML = newLabel;
       el.setAttribute("data-toggle-label", currentLabel);
     }

     if(classes.contains(TOGGLE_CLASS)){
      classes.remove(TOGGLE_CLASS)
      target.style.height = 0
    } else {
      classes.add(TOGGLE_CLASS)
      target.style.height = target.scrollHeight+'px'
    }

     e.preventDefault();
   };
 }

 new SlideToggle();
